import React, {FC, useEffect, useState} from 'react';
import {
    Space,
    Image,
    Breadcrumb,
    message,
    Table,
    Tag,
    Pagination,
    Tooltip,
    Button,
    Modal,
    Menu, Dropdown, Typography, Row, Col, Form, Input, Select, Card, Popconfirm
} from "antd";
import {Link, useHistory} from "react-router-dom";
import {restApi} from "../utils/variables";
import moment from "moment";
import {EditOutlined, CommentOutlined, DownOutlined, IdcardOutlined, RetweetOutlined, FileTextOutlined} from '@ant-design/icons'
import {SelectOptions} from "./CompanyEdit";
import {observer} from "mobx-react-lite";
import store from "../mobx/store";
import ButtonConfirm from "../components/ButtonConfirm";
import PdfPaymentFile from "../components/PDFPaymentFile";
import {EllipsisOutlined} from "@ant-design/icons/lib";

const {Title} = Typography
const {Option} = Select;
const {TextArea} = Input;
const {Meta} = Card;

interface OrderInterface {
    key?: string | number,
    id: number,
    timeOrder: string,
    typePay: string,
    statusOrder: string,
    sum: number | string,
    fio: string,
    phone: string,
    comment: string,
    typePackage: string,
    address: string,
    delivery: string,
    details: [],
    comment_by_admin: null | string,
    customer_id: number
}

interface ComponentProps {
    store: any
}

const Orders: FC<ComponentProps> = observer(() => {
    const history = useHistory()
    const [pageSize, setPageSize] = useState(0)
    const [currentPageSize, setCurrentPageSize] = useState(10)
    const [orders, setOrders] = useState<any[]>([])
    const [loading, setLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [visibleOrderModal, setVisibleOrderModal] = useState(false)
    const [visibleCommModal, setVisibleCommModal] = useState(false)
    const [currentEditOrder, setCurrentEditOrder] = useState<OrderInterface | undefined>(undefined)
    const [countries, setCountries] = useState<SelectOptions[]>([])
    const [regions, setRegions] = useState([])
    const [cities, setCities] = useState([])
    const [formEditModal] = Form.useForm()
    const [commEditModal] = Form.useForm()
    const [statusOrderModal, setStatusOrderModal] = useState('Не оплачено')
    const [visibleInvoiceModal, setVisibleInvoiceModal] = useState(false)

    useEffect(() => {
        getCountries()
    }, [])

    const handleCloseInvoiceModal = () => {
        setVisibleInvoiceModal(false)
    }

    const handleOkInvoiceModal = (ref: any, id: any) => {
        if (ref && ref.current) {
        } else {
            message.error('Непредвиденная ошибка скачивания счета на оплату!')
        }
        setVisibleInvoiceModal(false)
    }


    const menuStatusPay = (
        <Menu>
            <Menu.Item onClick={() => {
                setStatusOrderModal('Не оплачено')
                formEditModal.setFieldsValue({
                    statusOrder: 'Не оплачено',
                    sent: false,
                    paid: false,
                    delivered_and_closed: false
                })
            }}>
                <Tag color={'volcano'} key={'no-paid'}
                     style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    Не оплачено
                </Tag>
            </Menu.Item>
            <Menu.Item onClick={() => {
                setStatusOrderModal('Оплачено')
                formEditModal.setFieldsValue({
                    statusOrder: 'Оплачено',
                    sent: false,
                    paid: true,
                    delivered_and_closed: false
                })
            }}>
                <Tag color={'green'} key={'paid'}
                     style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    Оплачено
                </Tag>
            </Menu.Item>
            <Menu.Item onClick={() => {
                setStatusOrderModal('Отправлено')
                formEditModal.setFieldsValue({
                    statusOrder: 'Отправлено',
                    sent: true,
                    paid: true,
                    delivered_and_closed: false
                })
            }}>
                <Tag color={'cyan'} key={'sent'}
                     style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    Отправлено
                </Tag>
            </Menu.Item>
            <Menu.Item onClick={() => {
                setStatusOrderModal('Доставлено')
                formEditModal.setFieldsValue({
                    statusOrder: 'Доставлено',
                    sent: true,
                    paid: true,
                    delivered_and_closed: true
                })
            }}>
                <Tag color={'gold'} key={'delivered-and-closed'}
                     style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    Доставлено
                </Tag>
            </Menu.Item>
        </Menu>
    );

    const startMessage = async (idDetail: number, idPerson: number, idShop: number, data: any) => {
        const body = {
            "theme": "123",
            "detail": idDetail,
            "customer": idPerson,
            "company": idShop
        }
        const url = `${restApi}/marketplace/create_dialog/`
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': `Token ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })

        const json = await response.json()

        history.push({
            pathname: '/chats',
            search: `?chat_id=${json.id}`,
            state: {dialog: data}
        })
    }

    const getCountries = async () => {
        try {
            const url = `${restApi}/accounting_rest/countries/`
            const res = await fetch(url, {
                method: "GET",
                headers: {'Authorization': `Token ${localStorage.getItem('token')}`}
            })
            const json = await res.json()

            setCountries(json.results)
        } catch (e) {
            message.error('Ошибка получения стран');
            console.log(e)
        }
    }

    const getRegions = async (value: any) => {
        try {
            const url = `${restApi}/accounting_rest/regions/?country=${value['data-id']}`
            const res = await fetch(url, {
                method: "GET",
                headers: {'Authorization': `Token ${localStorage.getItem('token')}`}
            })
            const json = await res.json()
            const formatedData = json.results.map((item: any) => {
                return {
                    ...item,
                    alternate_names: item.alternate_names.split(';')[0]
                }
            })
            setRegions(formatedData)
        } catch (e) {
            message.error('Ошибка получения регионов');
            console.log(e)
        }
    }

    const getCities = async (value: any) => {
        try {
            const url = `${restApi}/accounting_rest/cities/?region=${value['data-id']}`
            const res = await fetch(url, {
                method: "GET",
                headers: {'Authorization': `Token ${localStorage.getItem('token')}`}
            })
            const json = await res.json()
            const formatedData = json.results.map((item: any) => {
                return {
                    ...item,
                    alternate_names: item.alternate_names.split(';')[0]
                }
            })
            setCities(formatedData)
        } catch (e) {
            message.error('Ошибка получения городов');
            console.log(e)
        }
    }

    const renderSelectOptions = (options: SelectOptions[]) => {
        return options.map((option) => {
            return <Option key={option.id} data-id={option.id}
                           value={option.alternate_names}>{option.alternate_names}</Option>
        })
    }

    const makeRefundFullOrder = async (order: any) => {
        try {
            const url = `${restApi}/marketplace/orders/refund/`
            const res = await fetch(url, {
                method: "POST",
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    order: order.id
                })
            })
            const json = await res.json()
            if (json.status == 'ok') {
                message.success('Операция прошла успешно!')
            }

            if (json.status == 'error') {
                message.error(`${json.text}`)
            }

        } catch (e) {
            console.log('order refund error', e)
            message.error('Ошибка выполнения операции!')
        }
    }

    const selectDelivery = (delivery: string | undefined) => {
        const deliveryArr = ["Деловые линии", "ПЭК", "СДЭК", "ТК КИТ (Кашалот)", "ТК Энергия", "ТК Луч", "ТК Экспресс-Авто", "Желдорэкспедиция"]
        return (
            <Select
                showSearch
                defaultValue={delivery ?? ''}
                placeholder="Доставка"
                optionFilterProp="children"
                filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            >
                {
                    deliveryArr.map(item => {
                        return <Option key={item} value={item}>{item}</Option>
                    })
                }
            </Select>
        )
    }

    const menu = (order: any) => {
        return (
            <Menu style={{width: 200}}>
                <Menu.Item key="0" icon={<EditOutlined/>} onClick={() => {
                    handleEditOrder(order)
                }}>
                    Редактировать
                </Menu.Item>
                {
                    order.typePay == 'Счет на оплату' ? (
                        <Menu.Item icon={<FileTextOutlined />} onClick={() => {
                            setVisibleInvoiceModal(true)
                            setCurrentEditOrder(order)
                        }}>
                            Счет на оплату
                        </Menu.Item>
                    ) : null
                }

                <Menu.Item icon={<RetweetOutlined/>}>
                    <Popconfirm
                        placement="rightBottom"
                        title="Вы в этом уверены?"
                        onConfirm={() => {
                            makeRefundFullOrder(order)
                        }}
                        okText="Да"
                        cancelText="Нет"
                    >
                        Полный возврат
                    </Popconfirm>
                </Menu.Item>
                <Menu.Item icon={<IdcardOutlined/>} onClick={() => {
                    setCurrentEditOrder(order)
                    commEditModal.setFieldsValue({comm: order.comment_by_admin})
                    setVisibleCommModal(true)
                }}>
                    Комментарий менеджера
                </Menu.Item>
            </Menu>
        )
    }

    const columns = [
        {
            title: 'Действия',
            key: 'action',
            render: (order: any) => (
                <Space size="middle">
                    <Dropdown overlay={menu(order)} trigger={["click"]}>
                        <EllipsisOutlined style={{cursor: "pointer", fontSize: "24px"}}/>
                    </Dropdown>
                </Space>
            ),
        },
        {title: 'ID', dataIndex: 'id', key: 'id'},
        {title: 'Время заказа', dataIndex: 'timeOrder', key: 'timeOrder'},
        {title: 'Тип оплаты', dataIndex: 'typePay', key: 'typePay'},
        {
            title: 'Статус заказа', dataIndex: 'statusOrder', key: 'statusOrder', render: (status: any) => (
                <Tag
                    color={status == 'Оплачено' ? 'green' : status == 'Не оплачено' ? 'volcano' : status == 'Отправлено' ? 'cyan' : 'gold'}
                    key={status}>
                    {status}
                </Tag>
            )
        },
        {title: 'Сумма', dataIndex: 'sum', key: 'sum'},
        {title: 'ФИО', dataIndex: 'fio', key: 'fio'},
        {title: 'Телефон', dataIndex: 'phone', key: 'phone'},
        {title: 'Комментарий к заказу', dataIndex: 'comment', key: 'comment'},
        {title: 'Тип упаковки', dataIndex: 'typePackage', key: 'typePackage'},
        {title: 'Адрес доставки', dataIndex: 'address', key: 'address'},
        {title: 'Доставка', dataIndex: 'delivery', key: 'delivery'},

    ];

    useEffect(() => {
        getOrders()
    }, [])

    const handleEditOrder = (order: any) => {
        setCurrentEditOrder(order)
        setStatusOrderModal(order?.statusOrder)

        formEditModal.setFieldsValue({
            time: order?.timeOrder,
            sum: order?.sum,
            fio: order?.fio,
            typePackage: order?.typePackage,
            phone: order?.phone,
            comment: order?.comment,
            address: order?.address,
            delivery: order?.delivery,
            statusOrder: order?.statusOrder,
            paid: order?.paid,
            sent: order?.sent,
            delivered_and_closed: order?.delivered_and_closed

        })

        setVisibleOrderModal(true)
    }

    const getStatusOrder = (paid: boolean, sent: boolean, delivered_and_closed: boolean, refund: any) => {
        if (refund && refund.partial) {
            return 'Частичный возврат'
        }

        if (refund && refund.finish) {
            return 'Полный возврат'
        }

        if (paid && sent && delivered_and_closed) {
            return 'Доставлено'
        }

        if (paid && sent && !delivered_and_closed) {
            return 'Отправлено'
        }

        if (paid && !sent) {
            return 'Оплачено'
        }

        if (!paid) {
            return 'Не оплачено'
        }
    }

    const getOrders = async (page = 1, pageSize = 10) => {
        setLoading(true)
        try {
            const url = `${restApi}/marketplace/orders/get_info_for_admin/?page=${page}&size=${pageSize}`
            const response = await fetch(url, {
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json',
                },

            })
            const json = await response.json()

            let formatDetailsForTable
            formatDetailsForTable = json.orders.map((order: any, idx: number) => {
                return {
                    key: idx,
                    id: order.order_id ?? '-',
                    timeOrder: order.date_create ? moment(order.date_create).format('LLL') : '-',
                    typePay: order.type_pay == 1 ? 'Оплата онлайн' : 'Счет на оплату',
                    statusOrder: getStatusOrder(order.paid, order.sent, order.delivered_and_closed, order.refund),
                    sum: order.pay_amount ?? '-',
                    fio: order.customer_name ?? '-',
                    phone: order.telephone_number ?? '-',
                    comment: order.comment ? order.comment : '-',
                    typePackage: order.packaging ? order.packaging : '-',
                    address: order.delivery_address ?? '-',
                    delivery: order.delivery_service ?? '-',
                    details: order.details,
                    comment_by_admin: order.comment_by_admin ?? '',
                    paid: order.paid,
                    sent: order.sent,
                    delivered_and_closed: order.delivered_and_closed,
                    customer_id: order.customer_id,
                    inn: order.inn ?? '',
                    name_ooo_or_ip: order.name_ooo_or_ip ?? ''
                }
            })
            setOrders(formatDetailsForTable)
            setPageSize(json.count)
            setLoading(false)
        } catch (e) {
            console.log('fetch orders error', e)
            message.error('Ошибка загрузки заказов')
        }
    }


    const expandedRowRender = (record: any) => {
        const columns = [
            {
                title: 'Действия',
                key: 'action',
                render: (row: any) => (
                    <Space size="middle">
                        <Tooltip title="Написать покупателю">
                            <Button shape="circle" icon={<CommentOutlined/>} onClick={async () => {
                                let data = {
                                    company: row.shop,
                                    detail: row.title,
                                    detail_id: row.id,
                                    photo: row.image
                                }
                                await startMessage(row.id, record.customer_id, row.company_id, data)
                            }}/>
                        </Tooltip>

                    </Space>
                ),
            },
            {title: 'ID', dataIndex: 'id', key: 'id'},
            {title: 'Артикул детали', dataIndex: 'article', key: 'article'},
            {
                title: 'Изображение', dataIndex: 'image', key: 'image', render: (url: string) => (
                    <>
                        {
                            url ? (
                                <Image
                                    style={{objectFit: 'cover'}}
                                    width={100}
                                    height={50}
                                    src={url}
                                />
                            ) : (
                                <Image
                                    style={{objectFit: 'cover'}}
                                    width={100}
                                    height={50}
                                    src="error"
                                    fallback="data:image/png;base64,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"
                                />
                            )
                        }
                    </>
                )
            },
            {title: 'Название детали', dataIndex: 'title', key: 'title'},
            {title: 'Марка-модель', dataIndex: 'brandModel', key: 'brandModel'},
            {title: 'OEM', dataIndex: 'oem', key: 'oem'},
            {title: 'Описание', dataIndex: 'description', key: 'description'},
            {title: 'Магазин', dataIndex: 'shop', key: 'shop'},
            {title: 'Количество', dataIndex: 'count', key: 'count'},
            {title: 'Стоимость', dataIndex: 'price', key: 'price'},
        ];

        const data = record.details.length > 0 ? record.details.map((item: any, idx: number) => {
            return {
                key: idx,
                id: item.id,
                article: item.shop_code_number,
                company_id: item.company_id,
                image: item.url,
                title: item.title,
                brandModel: `${item.brand} ${item.model}`,
                oem: item.oem ?? "-",
                shop: item.company_name ?? '-',
                count: 1,
                price: item.price,
                description: item.description
            }
        }) : [];

        return <Table columns={columns} dataSource={data} pagination={false}/>;
    };

    const changeAdminComment = async (order: number | string, comment: string) => {
        try {
            const url = `${restApi}/marketplace/orders/update_comment_admin/`
            await fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({order, comment})
            })
            message.success('Комментарий успешно отредактирован')
        } catch (e) {
            message.error('Ошибка редактирования комментария')
        }
    }

    const editOrder = async (id: number | string, data: any) => {
        try {
            const url = `${restApi}/marketplace/orders_admin/${id}/`
            await fetch(url, {
                method: 'PATCH',
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({...data})
            })
            message.success('Редактирование прошло успешно!')
        } catch (e) {
            console.log('edit order error', e)
            message.error('Ошибка редактирования заказа')
        }
    }

    const handleOrderChange = () => {
        formEditModal.validateFields().then(values => {
            if (currentEditOrder?.id) {
                const editData = {
                    delivery_address: values.address,
                    delivery_service: values.delivery,
                    telephone_number: values.phone,
                    packaging: values.typePackage,
                    delivered_and_closed: values.delivered_and_closed,
                    paid: values.paid,
                    sent: values.sent,
                    customer_name: values.fio,
                    comment: values.comment

                }
                editOrder(currentEditOrder.id, editData)
                getOrders(currentPage)
                setVisibleOrderModal(false)
            } else {
                message.error('Непредвиденная ошибка, попробуйте закрыть и открыть окно редактирования')
            }

        })

    }

    const handleCommChange = () => {
        commEditModal.validateFields().then(values => {
            if (currentEditOrder && currentEditOrder.id && values.comm) {
                changeAdminComment(currentEditOrder.id, values.comm)
                setVisibleCommModal(false)
                getOrders(currentPage)
            } else {
                message.error('Поле с комментарием не должно быть пустым!')
            }
        }).catch(e => {
            console.log(e)
        })
    }

    const removeDetailFromOrder = async (orderId: number, detailId: number) => {
        try {
            const url = `${restApi}/marketplace/orders/delete_detail_from_order/`
            await fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    order: orderId,
                    detail: detailId,
                })
            })
            message.success('Деталь возвращена в каталог!')
            setVisibleOrderModal(false)
            await getOrders(currentPage)
        } catch (e) {
            console.log('error delete detail from order', e)
            message.error('Ошибка удаления детали с заказа')
            setVisibleOrderModal(false)
        }
    }

    return (
        <div>
            <Breadcrumb style={{margin: '16px 0'}}>
                <Breadcrumb.Item><Link to={'/'}>Главная</Link></Breadcrumb.Item>
                <Breadcrumb.Item><Link to={'/orders'}>Заказы</Link></Breadcrumb.Item>
            </Breadcrumb>
            <div className="site-layout-background" style={{padding: 24, minHeight: 360}}>
                <Title level={2}>Заказы компании</Title>
                <div style={{marginTop: '10px'}}>
                    <Table showHeader
                           scroll={{x: 1750, y: 600}}
                           columns={columns}
                           loading={loading}
                           expandable={{expandedRowRender}}
                           dataSource={orders}
                           pagination={false}
                    />
                    <Pagination style={{marginTop: '10px'}} pageSize={currentPageSize} current={currentPage}
                                onChange={(page, pageSize) => {
                                    setCurrentPage(page)
                                    setCurrentPageSize(pageSize ? pageSize : 10)
                                    getOrders(page, pageSize ? pageSize : 10)
                                }} total={pageSize}/>
                </div>

                <Modal
                    title={`Редактирование заказа ID ${currentEditOrder?.id}`}
                    centered
                    visible={visibleOrderModal}
                    onOk={() => handleOrderChange()}
                    onCancel={() => {
                        // form.resetFields()
                        setVisibleOrderModal(false)
                    }}
                    okText="Редактировать"
                    cancelText="Закрыть"
                >
                    <Form layout="vertical"
                          form={formEditModal}>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="statusOrder"
                                    label="Статус заказа"
                                >
                                    <Dropdown overlay={menuStatusPay} trigger={['click']}>
                                        <Tag color={`${statusOrderModal == 'Не оплачено' ? 'volcano' :
                                            statusOrderModal == 'Оплачено' ? 'green' :
                                                statusOrderModal == 'Отправлено' ? 'cyan' : 'gold'
                                        }`} key={'statusOrder'} style={{
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            {statusOrderModal} <DownOutlined style={{marginLeft: '5px'}}/>
                                        </Tag>
                                    </Dropdown>
                                </Form.Item>
                                <Form.Item hidden name={'paid'}></Form.Item>
                                <Form.Item hidden name={'sent'}></Form.Item>
                                <Form.Item hidden name={'delivered_and_closed'}></Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name={'typePackage'}
                                    label={'Тип упаковки'}
                                >
                                    <Select
                                        showSearch
                                        placeholder="Тип упаковки"
                                        optionFilterProp="children"
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        <Option value="Жесткая упаковка">Жесткая упаковка</Option>
                                        <Option value="Без жесткой упаковки">Без жесткой упаковки</Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="fio"
                                    label="ФИО"
                                >
                                    <Input name="fio"/>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="phone"
                                    label="Телефон"
                                >
                                    <Input name="phone"/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="country"
                                    label="Страна"
                                >
                                    <Select showSearch

                                            filterOption={(input, option) =>
                                                option?.children && option?.children instanceof String ? option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 : false
                                            }
                                            placeholder="Выберите страну"
                                            onChange={(value, data) => {
                                                getRegions(data)
                                                formEditModal.setFieldsValue({'country': value, 'address': `${value},`})
                                            }}>
                                        {countries.length > 0 ? renderSelectOptions(countries) : null}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="region"
                                    label="Регион"
                                >
                                    <Select showSearch
                                            filterOption={(input, option) =>
                                                option?.children && option?.children instanceof String ? option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 : false
                                            }
                                            placeholder="Выберите регион"
                                            onChange={(value, data) => {
                                                getCities(data)
                                                formEditModal.setFieldsValue({
                                                    'region': value,
                                                    'address': `${formEditModal.getFieldValue('country')}, ${value}`
                                                })
                                            }}>
                                        {regions.length > 0 ? renderSelectOptions(regions) : null}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="city"
                                    label="Город"

                                >
                                    <Select showSearch
                                            onChange={(value) => {
                                                formEditModal.setFieldsValue({
                                                    'city': value,
                                                    'address': `${formEditModal.getFieldValue('country')}, ${formEditModal.getFieldValue('region')}, ${value}`
                                                })
                                            }
                                            }
                                            filterOption={(input, option) =>
                                                option?.children && option?.children instanceof String ? option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 : false
                                            }
                                            placeholder="Выберите город">
                                        {cities.length > 0 ? renderSelectOptions(cities) : null}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name={'delivery'}
                                    label={'Доставка'}
                                >
                                    {selectDelivery(currentEditOrder?.delivery)}
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    name={'address'}
                                    label={'Адрес получателя'}
                                >
                                    <Input name="address"/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="comment"
                                    label="Комментарий к заказу"
                                >
                                    <TextArea rows={3} name="comment"/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="time"
                                    label="Время заказа"
                                >
                                    <Input name="time"
                                           disabled={true}/>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="sum"
                                    label="Сумма"
                                >
                                    <Input name="sum"
                                           disabled={true}/>
                                </Form.Item>
                            </Col>
                        </Row>
                        {
                            currentEditOrder && currentEditOrder.details?.length > 0 ? (
                                <Row gutter={16} style={{
                                    maxHeight: '400px',
                                    overflow: 'auto'
                                }}>
                                    <Col style={{padding: '0 0 8px'}} span={24}><label>Детали в заказе</label></Col>
                                    {
                                        currentEditOrder.details.map((item: any) => {
                                            return (
                                                <Col span={12}>
                                                    <Card
                                                        style={{marginBottom: '24px'}}
                                                        cover={
                                                            <>
                                                                {
                                                                    item.url ? (
                                                                        <Image
                                                                            style={{objectFit: 'cover'}}
                                                                            height={100}
                                                                            src={item.url}
                                                                        />
                                                                    ) : (
                                                                        <Image
                                                                            style={{objectFit: 'cover'}}
                                                                            height={100}
                                                                            src="error"
                                                                            fallback="data:image/png;base64,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"
                                                                        />
                                                                    )
                                                                }
                                                            </>
                                                        }
                                                    >
                                                        <div className="ant-card-meta-detail">
                                                            <div className="ant-card-meta-title">{`${item.title}`}</div>
                                                            <div className="ant-card-meta-description" style={{
                                                                whiteSpace: 'nowrap',
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden'
                                                            }}>{`${item.brand} ${item.model}`}</div>
                                                            <b style={{cursor: 'pointer', color: '#1890ff'}}
                                                               onClick={() => {
                                                                   // message.error('Действие недоступно')
                                                                   removeDetailFromOrder(currentEditOrder.id, item.id,)
                                                               }}>Вернуть в каталог</b>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            )
                                        })
                                    }
                                </Row>

                            ) : null
                        }
                    </Form>
                </Modal>
                <Modal
                    title={`Комментарий менеджера по заказу ID ${currentEditOrder?.id}`}
                    centered
                    visible={visibleCommModal}
                    onOk={() => handleCommChange()}
                    onCancel={() => {
                        // form.resetFields()
                        setVisibleCommModal(false)
                    }}
                    okText="Редактировать"
                    cancelText="Закрыть">
                    <Form layout="vertical"
                          form={commEditModal}>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="comm"
                                    label="Комментарий менджера"
                                >
                                    <TextArea rows={3} name="comm"/>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>

                <PdfPaymentFile visible={visibleInvoiceModal}
                                handleClose={handleCloseInvoiceModal}
                                handleOk={handleOkInvoiceModal}
                                order={currentEditOrder}
                                orderDetails={currentEditOrder && currentEditOrder.details ? currentEditOrder.details : []}
                />

            </div>

        </div>
    );
});

export default Orders;